module.exports = __webpack_public_path__ + "img/lady.022caab6.jpg";